var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import createLabel from '../../requests/label/createLabel';
/**
 *
 */
var CreateLabelCommand = /** @class */ (function (_super) {
    __extends(CreateLabelCommand, _super);
    function CreateLabelCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param labelModel LabelModel
     * @param organisationId string
     * @param labelCollection LabelCollection
     * @param intl
     * @return {*}
     */
    CreateLabelCommand.prototype.execute = function (labelModel, organisationId, labelCollection, intl) {
        this.labelModel = labelModel;
        this.labelCollection = labelCollection;
        this.intl = intl;
        var promise = createLabel(labelModel, organisationId);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    CreateLabelCommand.prototype.then = function (response) {
        this.labelModel.update(response);
        this.labelCollection.add(this.labelModel);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.label.created' }, Object(this.labelModel)), 'dark', true);
    };
    return CreateLabelCommand;
}(Command));
export default CreateLabelCommand;
